import { useEffect } from "react";

import ShutdownPage from "src/routes/ShutdownPage";

// Murmur is shut down. The app is now a single static page that lets users
// withdraw funds from their embedded wallet. No backend, no socket, no contracts.
const App = () => {
    useEffect(() => {
        const initialLoadingPage = document.querySelector(
            ".initial-loading-page",
        );
        if (initialLoadingPage) {
            initialLoadingPage.remove();
        }
    }, []);

    return <ShutdownPage />;
};

export default App;
